import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import { Box, Button, Divider, IconButton } from '@mui/material'
import { ReactComponent as Logo } from 'assets/icons/Logo.svg'
import { IconDiary, IconInfo, IconLicense } from 'assets/sidebar'
import { DialogInfoApp, useDialog } from 'components/DialogV3'
import { TooltipCC } from 'components/common'
import { ICON } from 'constants/common'
import { getSidebarPath } from 'constants/route'
import { HEIGHT_COMPONENTS } from 'constants/ui.contants'
import SidebarItem from 'layouts/SidebarItem'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { selectCurrentUserFunctions } from 'store/selectors'
import theme, { color } from 'theme'
import './Layout.css'

export function getClassNavLink({ isActive, isPending }) {
    return isPending ? "pending" : isActive ? "nav-link nav-link-active" : "nav-link"
}

const SidebarCC = ({ isMobile = false, onClose }) => {
    const { t } = useTranslation()
    const functions = useSelector(selectCurrentUserFunctions)
    const { openDialog } = useDialog()

    const SIDEBAR_PATH = getSidebarPath({ functions });

    const handleOpenAbout = () => {
        openDialog(DialogInfoApp)
    }

    const sidebarContent = (
        <Box sx={{
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            overflowX: 'hidden',
            overflowY: 'scroll',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: '1'
        }}>
            {SIDEBAR_PATH.slice(1).map((item, index) => {
                return (
                    <Fragment key={index}>
                        {
                            item.path ? <SidebarItem path={item.path} code={item.code} Icon={item.Icon} labelKey={item.labelKey} requiredCodes={item.requiredCodes} onClose={onClose}/> :
                                <Divider>
                                    <Box sx={{ height: '1px', width: '10px', backgroundColor: "#949494", borderRadius: '30px' }}></Box>
                                </Divider>
                        }
                    </Fragment>
                )
            })}
            <Box>
                {false && <NavLink
                    to="manager-diary"
                    className={getClassNavLink}
                    children={({ isActive }) => (
                        <Fragment>
                            <IconDiary status={isActive ? ICON.STATUS.ACTIVE : ICON.STATUS.DEFAULT} />
                            {t('sidebar.managerDiary')}
                        </Fragment>
                    )}
                />}
                {false && <NavLink
                    to="license"
                    className={getClassNavLink}
                    children={({ isActive }) => (
                        <Fragment>
                            <IconLicense status={isActive ? ICON.STATUS.ACTIVE : ICON.STATUS.DEFAULT} />
                            {t('sidebar.license')}
                        </Fragment>
                    )}
                />}
            </Box>
            <TooltipCC title={t('goToInfoPage')}>
                <Button variant='text' onClick={handleOpenAbout} sx={{
                    color: theme.palette.text.primary,
                    padding: '9px 0px', marginTop: "6px", fontSize: '0.75em', fontWeight: '500', borderRadius: '0px', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: theme.spacing(0)
                }}>
                    <IconInfo />
                    {t('sidebar.info')}
                </Button>
            </TooltipCC>
        </Box>
    )

    if (isMobile) {
        return (
            <Box
                sx={{
                    width: '40vw',
                    minWidth: '150px',
                    height: "100%",
                    backgroundColor: color.greyIL06,
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <Box
                    sx={(theme) => ({ backgroundImage: `linear-gradient(${theme.palette.primary[1000]}, ${theme.palette.primary.dark})`,height: HEIGHT_COMPONENTS.HEADER,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        pl:1 })}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Logo style={{ width: '40px', height: '40px', cursor: 'pointer' }} onClick={onClose} />
                    </Box>
                    <TooltipCC title={t('close')}>
                        <IconButton onClick={onClose} sx={{ color: 'white' }}>
                            <ChevronLeftIcon fontSize="medium" />
                        </IconButton>
                    </TooltipCC>
                </Box>
                <Box sx={{ flex: 1, overflowY: 'auto', pt: 1.5, pl: 1 }}>
                    {SIDEBAR_PATH.slice(0, 1).map(item => (
                        <SidebarItem key={item.path} path={item.path} code={item.code} Icon={item.Icon} labelKey={item.labelKey} requiredCodes={item.requiredCodes} onClose={onClose}/>
                    ))}
                    {sidebarContent}
                </Box>
            </Box>
        )
    }

    return (
        <Box sx={{ height: "100%", backgroundColor: color.greyIL06, display: { xs: 'none', sm: 'flex' }, flexDirection: 'column', pt: 1.5 }}>
            {SIDEBAR_PATH.slice(0, 1).map(item => (
                <SidebarItem key={item.path} path={item.path} code={item.code} Icon={item.Icon} labelKey={item.labelKey} requiredCodes={item.requiredCodes} />
            ))}
            {sidebarContent}
        </Box>
    )
}

export default SidebarCC
